import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Draggable24 from "@carbon/icons-react/lib/draggable/24";
import Match from "./Match";

const MatchSummary = ({ index, match }) => {
	return (
		<Box
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			position="relative"
		>
			<Box>
				<Draggable24 />
			</Box>
			<Match match={match} disableActions index={index + 1} />
		</Box>
	);
};

MatchSummary.propTypes = {
	match: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired
};

export default MatchSummary;
